export default {
  'achPosPay.workspace.header': 'ACH Positive Pay',
  'achPosPay.pendingDecisions': 'Pending Decisions',
  'achPosPay.decisionsHistory': 'Decisions History',
  'achPosPay.paymentRules': 'Payment Rules'
};
